/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAwsCustomLensRecommendation {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAwsCustomLensRecommendation.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAwsCustomLensRecommendation>): WellArchitectedFrameworkAwsCustomLensRecommendation {
        let obj = Object.assign(new WellArchitectedFrameworkAwsCustomLensRecommendation(), model);
        WellArchitectedFrameworkAwsCustomLensRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAwsCustomLensRecommendation>): WellArchitectedFrameworkAwsCustomLensRecommendation {
        if (!model) return null;
        return WellArchitectedFrameworkAwsCustomLensRecommendation.newInstance(<WellArchitectedFrameworkAwsCustomLensRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAwsCustomLensRecommendation) {
        if (!obj) return;

        models.WellArchitectedFrameworkAwsCustomLensRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAwsCustomLensRecommendation): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAwsCustomLensRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Well Architected recommendation/description
     */
    displaytext: string;

    /**
     * Well Architected recommendation/description url
     */
    url: string;

}
